import { ValidatorFn, Validators } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LeistungsValidator {
    public static readonly LEISTUNG_MAX_3_DECIMAL = 999999.999;
    public static readonly LEISTUNG_PATTERN_3_DECIMAL = new RegExp('^\\d{0,6}([\.,][\\d]{1,3})?$');
    public static readonly LEISTUNG_MAX_6_DECIMAL = 999999.999999;
    public static readonly LEISTUNG_PATTERN_6_DECIMAL = new RegExp('^\\d{0,6}(\\.[\\d]{1,6})?$');

    static get validator3(): ValidatorFn[] {
        return [
            Validators.max(LeistungsValidator.LEISTUNG_MAX_3_DECIMAL),
            Validators.pattern(LeistungsValidator.LEISTUNG_PATTERN_3_DECIMAL),
        ];
    }
    static get validator6(): ValidatorFn[] {
        return [
            Validators.max(LeistungsValidator.LEISTUNG_MAX_6_DECIMAL),
            Validators.pattern(LeistungsValidator.LEISTUNG_PATTERN_6_DECIMAL),
        ];
    }
}


